import { UPDATE_SOCIAL_ENABLED } from '../actions';

export const socialChatEnabled = (state = false, action) => {
  switch (action.type) {
    case UPDATE_SOCIAL_ENABLED: {
      return action.enabled;
    }
    default:
      return state;
  }
};
